import { Component } from '@angular/core';

@Component({
  selector: 'app-location',
  templateUrl: './location.component.html',
  styleUrls: ['./location.component.scss'],
})
export class LocationComponent {

  seongsu = {
    latitude: 37.5443931,
    longitude: 127.04772120000007,
  }
  seoulsoop = {
    latitude: 37.547906,
    longitude: 127.044111,
  }

  constructor() { }
}


// WEBPACK FOOTER //
// ./src/app/heyground/location/location.component.ts